export const styles = `
    .quick-registration-layout {
      width: 100%;
    }
    .step-title {
      padding-top: 20px;
    }
    .step-subtitle {
      padding-bottom: 20px;
     }
     .field-wrapper{
        padding-left: 0px;
        padding-right: 0px;
      }
    .step-title,
    .step-subtitle {
        width: 100%;
        font-family: $lato;
        letter-spacing: 0;
        color: $black-regular;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0;
    }

    .step-title {
        font-size: 18px;
        font-weight: bold;
    }

    .step-subtitle {
        font-size: 16px;
    }

    .quick-registration-layout .non-student-layout {
      margin-bottom: 18px
    }

    .quick-registration-layout .field-wrapper {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }

    .quick-registration-layout .form-label {
      -webkit-box-align: center;
      -webkit-box-pack: start;
      align-items: left;
      color: rgb(53, 53, 53);
      display: flex;
      flex-direction: column;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 700;
      justify-content: flex-start;
      letter-spacing: 0px;
      line-height: 1;
      width: 100%;
      margin: 0px 0px 6px;
      padding: 0px;
    }

    .quick-registration-layout .form-error {
        -webkit-box-align: start;
        -webkit-box-pack: start;
        align-items: flex-start;
        color: red;
        display: flex;
        font-size: 12px;
        font-style: italic;
        font-weight: 700;
        justify-content: flex-start;
        min-height: 18px;
        width: 100%;
        margin: 0px;
        padding: 3px 0px 0px 2px;
    }
  .non-student-layout, .student-layout {
    width: 100%;
  }
    .quick-registration-layout .quick-profile-is-student-switch {
      margin-bottom: 32px;
      display: flex;
    }

    .quick-registration-layout .quick-profile-footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .job-title-count{
        text-align: right;
        float: right;
        color: rgb(224, 224, 224);
        font-weight: normal;
    }
    .quick-profile-is-student-switch{
        font-size: 16px;
        text-align: center;
        font-family: "Open Sans", sans-serif;
        color: rgb(152, 46, 169);
        margin-bottom: 32px;
        font-weight: 600;
        padding: 0px;
        background: none;
        outline: none;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
      }
      .error input {
        border-width: 1px;
        border-style: solid;
        border-color: rgb(179, 148, 242);
      }

`;

export const inputStyle = {
    backgroundColor: 'rgb(243, 245, 248)',
    color: 'rgb(53, 53, 53)',
    fontFamily: '"Open Sans", sans-serif',
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: '400',
    height: '50px',
    width: '100%',
    borderWidth: 'initial',
    borderStyle: 'none',
    borderColor: 'initial',
    borderImage: 'initial',
    borderRadius: '0px',
    outline: 'none',
};
